import { HubConnectionState } from "@microsoft/signalr";
import { SignalRContext } from "contexts/SignalRProvider";
import { useContext } from "react";
import { CircleFill } from "react-bootstrap-icons";
import styles from "./ConnectionStatus.module.css";

/**
 * Small status indicator showing SignalR connection state and joined groups.
 */
export const ConnectionStatus = (): React.ReactElement => {
  const signalR = useContext(SignalRContext);
  const connection = signalR?.connection;
  const groups = signalR?.groups;

  return (
    <CircleFill
      className={[
        connection?.state === HubConnectionState.Connected ? styles.connected : styles.notConnected,
      ].join(" ")}
      title={
        `Connection status: ${connection?.state === HubConnectionState.Connected ? "Connected" : "Not connected"}` +
        `\n${Array.from(groups ?? []).join(",\n")}`
      }
    />
  );
};

ConnectionStatus.displayName = "ConnectionStatus";
